import React from 'react';

import PortailAchatsWidgets from './PortailAchatsWidgets/PortailAchatsWidgets';

const WidgetsFrame = function () {
    return <PortailAchatsWidgets />;
};
export default WidgetsFrame;
